import { render, staticRenderFns } from "./ResponsiveTh.vue?vue&type=template&id=0d895161&"
import script from "./ResponsiveTh.vue?vue&type=script&lang=js&"
export * from "./ResponsiveTh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports